import base64url from 'base64url';
import { ResponseValidator, User, UserSettings } from 'oidc-client';
import QueryString from 'query-string';
import { setGlobal, useGlobal } from 'reactn';
import uuidv4 from 'uuidv4';
import { IGlobalState } from './states/GlobalState';
import { Principal } from './models/principal';
import { getIdentityFromSSO, getIdentityFromSSOByAlias, getIdentity } from './services/identityService';
import Auth, { clearAuthDataStorage, saveAuthData, saveIdentityInStorage } from './types/auth';
import publicIp from "react-public-ip";
import { LoggerServiceContext } from './logger/types';
import jwtDecode from 'jwt-decode';

const userManager = Auth.getDefaultUserManager()

const settings = () => userManager.settings

const dumpInfo = async () => {
    const tokenEndpoint = await userManager.metadataService.getTokenEndpoint()
    console.log({userManagerSettings: userManager.settings, tokenEndpoint});
}

function random() {
    return uuidv4().replace(/-/g, '');
}

type TokenResponse = {
    id_token: string,
    access_token: string,
    expires_in: number,
    token_type: string,
    scope: string,
}

export type StateType = {
    client_id: string,
    authority: string,
    nonce: string,
}

interface ISettingValidator {
    validator: ResponseValidator,
}

// const setPrincipalData = async (global: IGlobalState, authData: AuthDataType, user: User) => {
//     try
//     {
//         console.log('SSOVITTO sto per leggere identity dal server');
//         let identity = await getPrincipalData(global, authData, user);
//         console.log('SSOVITTO IMPOSTO identity');
//         setGlobal({...global, identity: identity});
//     }
//     catch(error)
//     {
//         console.error('SSOERROR setPrincipalData')
//         throw error;
//     }
// }

// const getPrincipalData = async (global: IGlobalState, authData: AuthDataType, user: User): Promise<Principal> => {  
//     try
//     {    
//         console.log('SSOVITTO sto per leggere username da sso is: ');
//         let username = authData.user;
//         console.log('SSOVITTO username da sso is: ' + username);
//         console.log({username});
//         console.log('SSOVITTO sto per leggere identity dal server: ' + username);
//         let identity = await getIdentityFromSSO(global, authData, user);
//         console.log('SSOVITTO ho letto identity');
//         return identity;
//     }
//     catch
//     {
//       // return Promise.reject();
//       console.error('SSOERROR Get Identity getPrincipalData')
//       throw new Error('Get Identity in errore in sso circle');
//     }
// }
  
const findIfTicketIsPresent = (): string | null => {    
    const loc = window.location.search;
    console.log({ loc });
    // console.log('Eseguo parse di: ' + loc);
    const qs = QueryString.parse(loc);
    console.log({ qs });
    console.log('Location', { loc, qs, wloc: window.location, });
    if((loc.indexOf('?tkt=') > -1) || (loc.indexOf('&tkt=') > -1)) {
        // console.log('tkt presente');
        return qs.tkt as string;
    }
    console.log('tkt non presente, ticket null');
    return null;
}

const retrieveAuthData = async (user: User, fromSSO: boolean) => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    console.log('SSOVITTO prima di getAuthData');
    const authData = await Auth.getAuthData(user.access_token, signal);
    if(authData) {
        console.log('AUTHDATA OK. SSOVITTO sto per fare save authData');        
        saveAuthData(authData, user);
        
        if (fromSSO) {
            console.log('SSOVITTO sto per recuperare il global state');        
            const myip = await publicIp.v4();
            try
            {
                // Per ora il sso Visura è utilizzato solo da Visura, Company Federated
                let identity: Principal = await getIdentity(myip, authData, user);
                console.log('Visura Recuperato identity: ' + identity?.Username)
                saveIdentityInStorage(identity);
            }
            catch(error)
            {
                console.error('SSOVIT Error da getIdentity: ' + JSON.stringify(error));
                clearAuthDataStorage(user);
                userManager.clearStaleState();
                userManager.removeUser();
                throw new Error('Utente non valido');
            }
        }
    } else {
        console.log('Auth Data NULL');        
    }
}

const processTicketIfPresent = async () => {
    // Discover if called by portal application
    const ticket = findIfTicketIsPresent();
    if(ticket) {
        // If a ticket is found we must use it to login via PieroIdentityServer response_type=pierosso
        console.log(`Ticket found <<<${ticket}>>>`)
        const state = createState();
        if(state) {
            await getToken(state, ticket, 'openid', 'profile', 'email', 'sixinfo', 'authinfoapi', 'iforf.api')
            console.log('*** getToken - END *** user should be stored !!!')
            // Dobbiamo anche recuperare authData
            const user = await userManager.getUser();
            console.log('Ho recuperato lo user tramite userManager: ' + user?.profile);
            if(user) {
                console.log('sto per eseguire RetrieveAuthData');
                await retrieveAuthData(user, true)
            }
            console.log('*** index.tsx ***: user', {user})

            return true;
        }
    }
    return false;  
}

const createState = () => {
    const settings = userManager.settings
    if(settings.client_id && settings.authority) {
        const state: StateType = {
            client_id: settings.client_id,
            authority: settings.authority,
            nonce: random(),
        }
        return state
    }
    return null
}

const getProfile = async (state: StateType, resp: TokenResponse) => {
    try {
        if((userManager.settings as ISettingValidator).validator) {
            const validator = (userManager.settings as ISettingValidator).validator;
            const sr = await validator.validateSigninResponse(state, resp);
            console.log('**** SigninResponse ****', {signinResponse: sr});
            const tt: any = jwtDecode(resp.access_token);
            console.log(`# Access token: ${JSON.stringify(tt, null, 2)}`);
            const rv = { 
                ...sr.profile, 
                name: tt.name,
                alias: tt['sx.user'] || tt.name,
            }
            // return sr.profile
            return rv;
        } else {
            console.warn('no ResponseValidatorCtor')
        }
    } catch(error) {
        console.error(error)
    }
    return {}
}

const getToken = async (state: StateType, ticket: string, ...scopes: string[]) => {
    console.log(`piero-sso-support:getToken(${ticket} for ${scopes})`)
    const tokenEndpoint = await userManager.metadataService.getTokenEndpoint()
    const appl = userManager.settings.client_id
    const secret = userManager.settings.client_secret
    const stateString = base64url.encode(JSON.stringify(state))
    const scope = scopes.join('%20')
    const ssoTag = process.env.REACT_APP_SSOTAG || 'ssosix'
    const options = {
        method: 'POST',
        body: `grant_type=piero_sso&scope=${scope}&ticket=${ticket}&client_id=${appl}&client_secret=${secret}&state=${stateString}&nonce=${state.nonce}&sso=${ssoTag}`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }
    console.log(`piero-sso-support:getToken:options ${options}`)
    //alert('Token consultool')
    if(tokenEndpoint) {
        console.log({tokenEndpoint})
        console.log(JSON.stringify(options))
        //alert('Sto per chiamare la fetch su endpoint')
        const response = await window.fetch(tokenEndpoint, options)
        if(response.status !== 200) {
            console.error(`Error fetching token: ${response.status} (${response.statusText})`)
            alert ('Errore in fetch sso')
            await userManager.removeUser()
            await userManager.clearStaleState()
            window.location.replace('/')
            return
        }
        console.log("Eseguita fetch sso con successo")
        const json = await response.json()
        const resp = json as TokenResponse;
        const expires_at = Date.now() / 1000 + resp.expires_in
        const us: UserSettings = {
            access_token: resp.access_token,
            expires_at,
            id_token: resp.id_token,
            scope: resp.scope,
            token_type: resp.token_type,
            state: state,
            profile: await getProfile(state, resp),
            session_state: ticket,
            refresh_token: '',
        }
        const user = new User(us);
        await userManager.storeUser(user);
        // console.log('user Stored', {user})
        console.log('user Stored serialized:', JSON.stringify(user));
    }
}

export default {
    settings,
    dumpInfo,
    getToken,
    createState,
    processTicketIfPresent,
}
